import React from 'react';
import { useAudio } from '../context/AudioContext';
import './AudioPlayer.css';

function AudioPlayer() {
  const {
    activeFrequency,
    audioEnabled,
    isPlaying,
    currentTrackIndex,
    audioTracks,
    togglePlayPause,
    handleNext,
    handlePrevious,
  } = useAudio();

  if (!audioEnabled || !activeFrequency) {
    return null;
  }

  // Check if frequency has audio files
  if (!audioTracks || audioTracks.length === 0) {
    return null;
  }

  return (
    <div className="audio-player" data-testid="audio-player">
      <div className="audio-player-content">
        <div className="audio-info">
          <span className="audio-freq-icon" style={{ color: activeFrequency.color_hex }}>
            🎵
          </span>
          <div className="audio-freq-details">
            <span className="audio-freq-name">{activeFrequency.name}</span>
            <span className="audio-track-info">
              Track {currentTrackIndex + 1} von {audioTracks.length}
            </span>
          </div>
        </div>

        <div className="audio-controls">
          <button
            onClick={handlePrevious}
            className="control-button"
            data-testid="previous-button"
            disabled={audioTracks.length <= 1}
            title="Vorheriger Track"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M6 6h2v12H6zm3.5 6l8.5 6V6z"/>
            </svg>
          </button>

          <button
            onClick={togglePlayPause}
            className="play-button-main"
            data-testid="play-pause-button"
            style={{ 
              borderColor: activeFrequency.color_hex,
              color: activeFrequency.color_hex 
            }}
            title={isPlaying ? 'Pause' : 'Abspielen'}
          >
            {isPlaying ? (
              <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                <rect x="6" y="4" width="4" height="16" rx="1" />
                <rect x="14" y="4" width="4" height="16" rx="1" />
              </svg>
            ) : (
              <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                <path d="M8 5v14l11-7z" />
              </svg>
            )}
          </button>

          <button
            onClick={handleNext}
            className="control-button"
            data-testid="next-button"
            disabled={audioTracks.length <= 1}
            title="Nächster Track"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}

export default AudioPlayer;
